export const xsmall = 'xsmall';
export const small = 'small';
export const normal = 'normal';
export const large = 'large';
//# sourceMappingURL=sizes.js.map